import { LoadingStates } from '@pb/utils'
import { createReducer } from 'redux-act'

import actions from './actions'
import initialState from './initialState'

const fetchIAFLabelsStart = (state): any => ({
  ...state,
  iafLabelsStatus: LoadingStates.Loading,
})

const fetchIAFLabelsSuccess = (state, data): any => ({
  ...state,
  iafLabelsStatus: LoadingStates.LoadedSuccess,
  iafLabels: data?.content || [],
})

const fetchIAFLabelsFail = (state): any => ({
  ...state,
  iafLabelsStatus: LoadingStates.LoadedFail,
})

export default createReducer((on) => {
  on(actions.fetchIAFLabelsStart, fetchIAFLabelsStart)
  on(actions.fetchIAFLabelsSuccess, fetchIAFLabelsSuccess)
  on(actions.fetchIAFLabelsFail, fetchIAFLabelsFail)
}, initialState)
